import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import moment from 'moment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';

import './css/mix365djs.css';

export default class Mix365djs extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			djshows: {},
      djs: {},

		};
  };

  
  
  async componentDidMount() {
		document.title = "Mix365 DJ'S | Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var params = new URLSearchParams();
		params.append('djshows','1');
		params.append('djperiod','alltime');
		const x = await postApi('/api/v2/djarea/statistics', params);
		this.setState({djshows: x.data.djshows, status: true});

		var params2 = new URLSearchParams();
		params2.append( 'profile', this.state.profile );
		const y = await postApi('/api/v2/about', params2);
		this.setState({djs: y.data});
	}

	componentWillUnmount() {
	}


	

	render() {
		const user = this.context;
		const djs = 
      Object.keys(this.state.djs).map((e,i) => {
				let country = this.state.djs[e].country_default.toString();
				if( country && country.indexOf('/') > 0 ) {
					country = country.split('/')[1];
				}
        return (
					<>
						<Col md={6} xl={4}>
							<div className="mix365djs-card" style={{}}>
								<Row className="gx-0 mix365djs-description">
									<Col xs={5} md={4}>
										<div className="mix365djs-avatar" style={{position: 'relative'}}>
											<Link to={`/${this.state.djs[e].username.replaceAll(' ','%20')}`}>
												<img src={`https://mix365.co.uk/${this.state.djs[e].avatar}`} alt="DJ Profile Avatar" className="mix365djs-avatar-img" width="100%" />
											</Link>
										</div>
									</Col>
									<Col className="text-vcenter">
										<Row className="gx-0">
											<Col xs={12}>
												<Link to={`/${this.state.djs[e].username.replaceAll(' ','%20')}`}>
													{this.state.djs[e].title?this.state.djs[e].title:this.state.djs[e].username}<br />
												</Link>
											</Col>
											<Col xs={12} className="profile-country">
												{user.user?.access?.level>=20&&this.state.djs[e].country_default.length>0&&
													<><FontAwesomeIcon icon="location-dot" /> {country}<br /></>
												}
												<FontAwesomeIcon icon={['far', 'clock']} /> Joined {moment(this.state.djs[e].joined*1000).format("Do MMMM YYYY")}
											</Col>
							
											<Col xs={12}>
												<ul className="mix365djs-socials">
													{this.state.djs[e].facebook &&
														<li>
															<a href={this.state.djs[e].facebook} title="Facebook" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
															</a>
														</li>
													}
													{/*<li>H</li>*/}
													{this.state.djs[e].instagram &&
														<li>
															<a href={this.state.djs[e].instagram} title="Instagram" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.djs[e].mixcloud &&
														<li>
															<a href={this.state.djs[e].mixcloud} title="Mixcloud" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.djs[e].soundcloud &&
														<li>
															<a href={this.state.djs[e].soundcloud} title="Soundcloud" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.djs[e].twitch &&
														<li>
															<a href={this.state.djs[e].twitch} title="Twitch" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.djs[e].youtube &&
														<li>
															<a href={this.state.djs[e].youtube} title="Youtube" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" />
															</a>
														</li>
													}
												</ul>
											</Col>
										</Row>
									</Col>
								</Row>
								<Row className="gx-0 mix365djs-about-box">
									<Col>
										<OverlayTrigger key="performances" placement="bottom" overlay={
												<Tooltip id="tooltip-performances">{this.state.djs[e].performances} Performances</Tooltip>
											}><span style={{fontSize:12}}><FontAwesomeIcon icon="compact-disc" style={{fontSize:14}} /> {this.state.djs[e].performances}</span>
										</OverlayTrigger>
									</Col>
									<Col>
										<OverlayTrigger key="plays" placement="bottom" overlay={
												<Tooltip id="tooltip-plays">{this.state.djs[e].listeners} Plays</Tooltip>
											}><span style={{fontSize:12}}><FontAwesomeIcon icon="play" style={{fontSize:14}} /> {this.state.djs[e].listeners}</span>
										</OverlayTrigger>
										</Col>
									<Col>
										<OverlayTrigger key="favorites" placement="bottom" overlay={
												<Tooltip id="tooltip-favorites">{this.state.djs[e].favorites} Favorites</Tooltip>
											}><span style={{fontSize:12}}><FontAwesomeIcon icon="heart" style={{fontSize:14}} /> {this.state.djs[e].favorites}</span>
										</OverlayTrigger>
										</Col>
									<Col>
										<OverlayTrigger key="likes" placement="bottom" overlay={
												<Tooltip id="tooltip-likes">{this.state.djs[e].likes} Likes</Tooltip>
											}><span style={{fontSize:12}}><FontAwesomeIcon icon="thumbs-up" style={{fontSize:14}} /> {this.state.djs[e].likes}</span>
										</OverlayTrigger>
										</Col>
									<Col>
										<OverlayTrigger key="hours" placement="bottom" overlay={
												<Tooltip id="tooltip-hours">{this.state.djs[e].hours} Hours</Tooltip>
											}><span style={{fontSize:12}}><FontAwesomeIcon icon="hourglass-empty" style={{fontSize:14}} /> {this.state.djs[e].hours}</span>
										</OverlayTrigger>
									</Col>
								</Row>
								<Row className="mix365djs-bottom gx-0">
									<Col className="mix365djs-biography">
										{this.state.djs[e].biography.substring(0,300)}<br />
									</Col>
								</Row>
							</div>
						</Col>
					</>
				)
			})
		return (
			<>
				{this.state.status &&
					<>
						<div className="live">
							<div className="live-background"></div>
						</div>

						<div className="article">
							<Row className="gx-0 pb-5">
								<Col className="live-header">
									<h3>Mix365 Clubbers and Radio DJ's</h3>
								</Col>
								
							</Row>
							
							<Row>
								{djs}
							</Row>
						</div>
					</>
				}
			</>
		);
	}
}
